var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#2F1F19",
  strokeWidth: 1.5,
  transform: "translate(10 10)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.115,
  height: 17.28,
  x: 0.599,
  y: 0.845,
  rx: 1.25,
  transform: "matrix(.98936 .14551 -.19023 .98174 3.74 .428)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.924 11.218 16.752 1.281m-9.534-9.99-1.567 8.839m6.376.288-2.094 8.715"
}))));
export default SvgIconSector;